export const GoogleMapApiConfig = 'AIzaSyCLrzWmGmPcGt68t3wUQ2HE7heG8SzPvzM';